import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { ContactTiersReadNoteGroupTimestampableBlameambleGroup } from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { TIERS_REDUCER_NAME } from './constants';
import { buildTiersRedux } from './tiersReducer';

const { reducer } = buildTiersRedux({});

export const tiersReducer = combineReducers({
    [TIERS_REDUCER_NAME]: reducer,
});

export const tiersStore = configureStore({
    reducer: tiersReducer,
    devTools: {
        name: 'Tiers Store',
    },
});

export type TiersReducerType = typeof tiersReducer;
export type TiersStateType = ReturnType<typeof tiersStore.getState>;
export type TiersAppDispatch = typeof tiersStore.dispatch;
export type ContactTiersRead = ContactTiersReadNoteGroupTimestampableBlameambleGroup;
